import { CardTitleInQA, GradedStatus, UngradedStatus } from "models/cardIngestion";
import { gradedDisplay } from "util/graders";
import CellDisplay from "./CellDisplay";

const GradeOrConditionDisplay = ({
    conditionName,
    gradingCompanyId,
    gradeId,
    gradeName,
    isLot,
    statusId,
    statusName
}: CardTitleInQA) => {
    if (isLot) {
        return <CellDisplay
            value={statusName}
            errorIf={!statusName}
        />;
    }

    if (gradingCompanyId === null) {
        return <CellDisplay
            value={conditionName}
            errorIf={statusId !== UngradedStatus.id}
        />
    }

    return <CellDisplay
        value={gradedDisplay(gradingCompanyId, gradeName)}
        errorIf={statusId !== GradedStatus.id || gradeId === null}
    />
};

export default GradeOrConditionDisplay;